import _ from 'lodash';

type GetSpeech = () => Promise<string>;

const getSpeech: GetSpeech = () => {
  return new Promise((resolve) => {
    // @ts-ignore
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    const recognition = new SpeechRecognition();

    recognition.onstart = () => {};

    recognition.onspeechend = () => {
      recognition.stop();
      resolve('');
    };

    // @ts-ignore
    recognition.onresult = (result) => {
      const vocalInput = result.results[0][0].transcript;
      // console.log('Recognized Text:', vocalInput);
      resolve(vocalInput);
    };

    recognition.start();
  });
};

interface SearchData {
  title: string;
  content: string;
  path: string;
  keyword: string;
}

const parseSearchData = (): SearchData[] => {
  const elements = document.querySelectorAll('.serch-data');
  const dataArray: SearchData[] = [];

  elements.forEach((element) => {
    const item = element as HTMLElement;

    dataArray.push({
      title: item.dataset.title || '',
      content: item.dataset.content || '',
      path: item.dataset.path || '',
      keyword: item.dataset.keyword || '',
    });
  });

  return dataArray;
};

const clearResults = () => {
  const items = document.querySelectorAll('.results__item');
  items.forEach((item) => {
    item.parentNode?.removeChild(item);
  });
};

const searchItems = (data: SearchData[], searchString: string): SearchData[] => {
  if (!searchString) return [];
  const cleanString = (str: string): string => {
    return str
      .replace(/&nbsp;/g, ' ')
      .replace(/<span[^>]*>.*?<\/span>/g, '')
      .toLowerCase();
  };
  const cleanSearchString = searchString.toLowerCase();
  return _(data)
    .map((item) => {
      let score = 0;
      const cleanContent = cleanString(item.content);
      if (item.title.toLowerCase().includes(cleanSearchString)) {
        score += 2; // Double score for title match
      }
      if (cleanContent.includes(cleanSearchString)) {
        score += 1; // Single score for content match
      }
      if (item.keyword.toLowerCase().includes(cleanSearchString)) {
        score += 1; // Single score for keyword match
      }
      return { item, score };
    })
    .filter(({ score }) => score > 0)
    .orderBy(['score'], ['desc'])
    .map(({ item }) => item)
    .value();
};

const addSearchResultsToDOM = (results: SearchData[], resultsContainer: HTMLDivElement): void => {
  resultsContainer.innerHTML = '';

  if (results.length === 0) {
    const noResultsMessage = document.createElement('div');
    noResultsMessage.className = 'no-results-message';
    noResultsMessage.textContent = 'No results found, please try with different keywords';
    resultsContainer.appendChild(noResultsMessage);
    return;
  }

  results.forEach((result) => {
    const itemDiv = document.createElement('div');
    itemDiv.className = 'results__item';

    const titleElement = document.createElement('h4');
    titleElement.textContent = result.title;

    const linkElement = document.createElement('a');
    linkElement.href = result.path;
    linkElement.target = '_blank';
    linkElement.appendChild(titleElement);

    const spanElement = document.createElement('span');
    spanElement.className = 'visually-hidden';
    spanElement.textContent = 'opens the link in a new tab';
    linkElement.appendChild(titleElement);
    linkElement.appendChild(spanElement);

    const divider = document.createElement('div');
    divider.className = 'decor-divider ';

    if (resultsContainer.classList.contains('results__intermediary')) {
      divider.classList.add('decor-verdigris');
    }

    const contentParagraph = document.createElement('p');
    console.log('contentParagraph', contentParagraph);
    const sanitizedContent = result.content.replace(/&nbsp;/g, '').replace(/<span[^>]*>.*?<\/span>/g, '');
    contentParagraph.textContent = sanitizedContent;

    itemDiv.appendChild(linkElement);
    itemDiv.appendChild(divider);
    itemDiv.appendChild(contentParagraph);

    resultsContainer.appendChild(itemDiv);
  });
};

// ---------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('search-input') as HTMLInputElement;
  const searchButton = document.getElementById('search-button') as HTMLButtonElement;
  const dictateButton = document.getElementById('dictate-button') as HTMLButtonElement;
  const resultsContainer = document.getElementById('results') as HTMLDivElement;

  const data = parseSearchData();
  let serchString = '';

  input.addEventListener('input', (event) => {
    const value = (event.target as HTMLInputElement).value;
    serchString = value;
    const res = searchItems(data, value);
    addSearchResultsToDOM(res, resultsContainer);
  });

  searchButton.addEventListener('click', () => {
    const res = searchItems(data, serchString);
    addSearchResultsToDOM(res, resultsContainer);
  });

  dictateButton.addEventListener('click', () => {
    dictateButton.classList.add('active');

    getSpeech()
      .then((vocalInput) => {
        if (vocalInput) {
          input.value = vocalInput;
          const res = searchItems(data, vocalInput);
          addSearchResultsToDOM(res, resultsContainer);
        }
      })
      .finally(() => {
        dictateButton.classList.remove('active');
      });
  });
});
